import React from 'react'

import Button from 'components/Button'

import s from './ConfirmModal.scss'
import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

export default props => {
  const { modalConfirm, title, message, textSize, altButton, button } = props
  return (
    <div
      className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sLay.flex, s.body)}
    >
      {title && (
        <div className={sText.descrip1} style={{ marginBottom: '30px' }}>
          {title}
        </div>
      )}

      <div
        className={textSize === 'sm' ? sText.descrip2 : sText.descrip1}
        dangerouslySetInnerHTML={{ __html: message }}
      />
      <br />
      <br />
      <br />
      <div className={cn(sLay['layout-xs-column'], sLay['layout-gt-xs-row'])}>
        <Button style={{ margin: '5px' }} onClick={modalConfirm} color="tertiary">
          {button || 'Continue'}
        </Button>
        {altButton && (
          <Button
            style={{ margin: '5px' }}
            onClick={() => modalConfirm('alt')}
            ghost
            color="tertiary"
          >
            {altButton}
          </Button>
        )}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Modal/ConfirmModal/ConfirmModal.jsx